module.exports = __webpack_public_path__ + "img/RORBPJR40064.058ebcf8.png";